// extracted by mini-css-extract-plugin
export var actions = "_mj-d";
export var benefitCard = "_mj-a";
export var benefitIcon = "_mj-b";
export var benefitLabel = "_mj-c";
export var benefits = "_mj-9";
export var bodyText = "_mj-8";
export var closeButton = "_mj-2";
export var content = "_mj-3";
export var eyebrow = "_mj-4";
export var heading = "_mj-5";
export var image = "_mj-f";
export var imagePanel = "_mj-e";
export var modal = "_mj-0";
export var shell = "_mj-1";
export var title = "_mj-6";
export var titleOffer = "_mj-7";